import axios from 'axios';
import qs from 'qs';

export const BUHTABLE_RECORDS_GET = 'BUHTABLE_RECORDS_GET';
export const BUHTABLE_RECORDS_GET_PENDING = 'BUHTABLE_RECORDS_GET_PENDING';
export const BUHTABLE_RECORDS_GET_REJECTED = 'BUHTABLE_RECORDS_GET_REJECTED';
export const BUHTABLE_RECORDS_GET_FULFILLED = 'BUHTABLE_RECORDS_GET_FULFILLED';

export const BUHTABLE_RECORD_VALUES_SET = 'BUHTABLE_RECORD_VALUES_SET';

export const BUHTABLE_RECORD_UPDATE = 'BUHTABLE_RECORD_UPDATE';
export const BUHTABLE_RECORD_UPDATE_PENDING = 'BUHTABLE_RECORD_UPDATE_PENDING';
export const BUHTABLE_RECORD_UPDATE_REJECTED = 'BUHTABLE_RECORD_UPDATE_REJECTED';
export const BUHTABLE_RECORD_UPDATE_FULFILLED = 'BUHTABLE_RECORD_UPDATE_FULFILLED';

export const BUHTABLE_RECORD_CREATE = 'BUHTABLE_RECORD_CREATE';
export const BUHTABLE_RECORD_CREATE_PENDING = 'BUHTABLE_RECORD_CREATE_PENDING';
export const BUHTABLE_RECORD_CREATE_REJECTED = 'BUHTABLE_RECORD_CREATE_REJECTED';
export const BUHTABLE_RECORD_CREATE_FULFILLED = 'BUHTABLE_RECORD_CREATE_FULFILLED';

export const BUHTABLE_RESET = 'BUHTABLE_RESET';

export const buhtableRecordsGet = (year, month, token) => {
    return (dispatch) => {
        dispatch({ type: BUHTABLE_RECORDS_GET_PENDING });
        return axios(`https://gstables.grandsova.com/api/buhtable/${year}/${month}`, {
            method: 'GET',
            headers: {
                'Authorization': token
            }
        })
        .then(response => {
            dispatch({
                type: BUHTABLE_RECORDS_GET_FULFILLED,
                payload: response.data
            })
        })
        .catch(error => {
            dispatch({
                type: BUHTABLE_RECORDS_GET_REJECTED,
                error: error
            })            
        })        
    }
};

export const buhtableRecordValuesSet = (record) => {
    return {
        type: BUHTABLE_RECORD_VALUES_SET,
        record
    }
};

export const buhtableRecordUpdate = (year, record, token) => {
    return (dispatch) => {
        dispatch({ type: BUHTABLE_RECORD_UPDATE_PENDING });
        return axios(`https://gstables.grandsova.com/api/buhtable/${record.id}`, {
            method: 'POST',
            headers: {
                'Authorization': token
            },
            data: qs.stringify({
                year,
                record
            })
        })
        .then(response => {
            dispatch({
                type: BUHTABLE_RECORD_UPDATE_FULFILLED,
                payload: response.data
            })
        })
        .catch(error => {
            dispatch({
                type: BUHTABLE_RECORD_UPDATE_REJECTED,
                error: error
            })            
        })        
    }
};

export const buhtableRecordCreate = (year, month, token) => {
    return (dispatch) => {
        dispatch({ type: BUHTABLE_RECORD_CREATE_PENDING });
        return axios(`https://gstables.grandsova.com/api/buhtable`, {
            method: 'POST',
            headers: {
                'Authorization': token
            },
            data: qs.stringify({
                year,
                month
            })
        })
        .then(response => {
            dispatch({
                type: BUHTABLE_RECORD_CREATE_FULFILLED,
                payload: response.data
            })
        })
        .catch(error => {
            dispatch({
                type: BUHTABLE_RECORD_CREATE_REJECTED,
                error: error
            })            
        })        
    }
};

export const buhtableReset = () => {
    return {
        type: BUHTABLE_RESET,
    }
};


// WEBPACK FOOTER //
// ./src/_actions/buhtable.js